export class BusinessNotificationSettingsInput {
    id!: number | null;
    askClientForReview!: boolean | null;
    sendNewBookingEmail!: boolean | null;
    sendNewBookingSMS!: boolean | null;
    sendRescheduleBookingEmail!: boolean | null;
    sendRescheduleBookingSMS!: boolean | null;
    sendCancellationBookingEmail!: boolean | null;
    sendCancellationBookingSMS!: boolean | null;
    sendDeclineBookingEmail!: boolean | null;
    sendDeclineBookingSMS!: boolean | null;
    sendNewEntryWaitListEmail!: boolean | null;
    sendNewEntryWaitListSMS!: boolean | null;
    sendCancellationWaitListEmail!: boolean | null;
    sendCancellationWaitListSMS!: boolean | null;
    sendConfirmationEmail!: boolean | null;
    textForConfirmationEmail!: string | null;
    sendConfirmationSMS!: boolean | null;
    textForConfirmationSMS!: string | null;
    sendAppointmentReminderEmail!: boolean | null;
    textForAppointmentReminderEmail!: string | null;
    sendAppointmentReminderSMS!: boolean | null;
    textForAppointmentReminderSMS!: string | null;
    sendFinishAppointmentEmail!: boolean | null;
    textForFinishAppointmentEmail!: string | null;
    sendFinishAppointmentSMS!: boolean | null;
    textForFinishAppointmentSMS!: string | null;
    sendAppointmentReebokReminderEmail!: boolean | null;
    textForAppointmentRebookReminderEmail!: string | null;
    sendBirthdayEmail!: boolean | null;
    textForBirthdayEmail!: string | null;
    sendBirthdaySMS!: boolean | null;
    textForBirthdaySMS!: string | null;
    // Custom copy for the lifecycle events that were previously toggle-only.
    textForNewBookingEmail!: string | null;
    textForNewBookingSMS!: string | null;
    textForRescheduleBookingEmail!: string | null;
    textForRescheduleBookingSMS!: string | null;
    textForCancellationBookingEmail!: string | null;
    textForCancellationBookingSMS!: string | null;
    textForDeclineBookingEmail!: string | null;
    textForDeclineBookingSMS!: string | null;
    textForNewEntryWaitListEmail!: string | null;
    textForNewEntryWaitListSMS!: string | null;
    textForCancellationWaitListEmail!: string | null;
    textForCancellationWaitListSMS!: string | null;
    textForReviewEmail!: string | null;
    sendNewBookingInApp!: boolean | null;
    sendNewBookingPush!: boolean | null;
    sendRescheduleBookingInApp!: boolean | null;
    sendRescheduleBookingPush!: boolean | null;
    sendCancellationBookingInApp!: boolean | null;
    sendCancellationBookingPush!: boolean | null;
    sendDeclineBookingInApp!: boolean | null;
    sendDeclineBookingPush!: boolean | null;
    sendNewEntryWaitListInApp!: boolean | null;
    sendNewEntryWaitListPush!: boolean | null;
    sendCancellationWaitListInApp!: boolean | null;
    sendCancellationWaitListPush!: boolean | null;
    sendConfirmationInApp!: boolean | null;
    sendConfirmationPush!: boolean | null;
    sendAppointmentReminderInApp!: boolean | null;
    sendAppointmentReminderPush!: boolean | null;
    sendFinishAppointmentInApp!: boolean | null;
    sendFinishAppointmentPush!: boolean | null;
    sendAppointmentReebokReminderInApp!: boolean | null;
    sendAppointmentReebokReminderPush!: boolean | null;
    sendBirthdayInApp!: boolean | null;
    sendBirthdayPush!: boolean | null;
    notifyTeamNewBooking!: boolean | null;
    notifyTeamCancellation!: boolean | null;
    notifyTeamReschedule!: boolean | null;
    notifyTeamIncludeOwner!: boolean | null;
}
